import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Col, Label, FormGroup } from 'reactstrap';
import { Field, getFormValues } from 'redux-form';
import { Utils } from '../../../../../services';

const is_random_movie = (value) => (
    value === true || value === 'true' || value === 1 || value === '1'
);

const FeaturedMovie = ({ env, screen, widget }) => {
    const { t } = useTranslation();
    const formValues = useSelector((state) => getFormValues('settingForm')(state));
    const live_widget = formValues?.mobile?.[env]?.screens?.[screen]?.widgets?.[widget.index];
    const random_movie = is_random_movie(
        live_widget?.randomMovie ?? widget?.randomMovie
    );

    return (
        <>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.random_featured_movie') }
                </Label>
                <Col sm={ 8 }>
                    <Field
                        component="select"
                        className="form-control"
                        name={ `mobile.${env}.screens.${screen}.widgets[${widget.index}].randomMovie` }
                        normalize={ Utils.normalizeBoolean }
                    >
                        <option value="false">{ t('common.no') }</option>
                        <option value="true">{ t('common.yes') }</option>
                    </Field>
                </Col>
            </FormGroup>
            { !random_movie && (
                <FormGroup row className="widget-setting">
                    <Label className="col-sm-4">
                        { t('settings.mobile.screens.widget.settings.featured_movie_id') }
                    </Label>
                    <Col sm={ 8 }>
                        <Field
                            type="text"
                            component="input"
                            className="form-control"
                            name={ `mobile.${env}.screens.${screen}.widgets[${widget.index}].movie` }
                        />
                    </Col>
                </FormGroup>
            ) }
        </>
    );
};

export default FeaturedMovie;
